<template>
  <div class="container">
    <div class="box--title">
      <h1 class="title">MustWatch</h1>
      <div class="btn--filter">
        <span :class="{ active: movies }" @click="toggleVisibility('Movies')"
          >• All Time Top 100 {{ paramsMust.language }} Movies •</span
        >
        <span :class="{ active: !movies }" @click="toggleVisibility('Series')"
          >• Popular {{ paramsMust.language }} TV Shows •</span
        >
      </div>
    </div>

    <ith-must-watch-grid-detail />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["items_user", "paramsMust"]),
  data: () => ({
    title: "Watchlist",
    movies: true
  }),
  methods: {
    toggleVisibility(params) {
      this.$store.commit("EDIT_ITEMS_VISIBILITY_MUSTWATCHED_SHOWS", params);
      params == "Movies" ? (this.movies = true) : (this.movies = false);
    }
  },

  watch: {},

  mounted() {
    this.items_user.mustwatched == "Movies"
      ? (this.movies = true)
      : (this.movies = false);
  }
};
</script>

<style scoped>
.container {
  position: relative;
  display: grid;
}
.box--title {
  display: grid;
  grid-template-rows: 80px;
  grid-template-columns: 100%;
  justify-content: start;
  align-items: center;
  margin-bottom: 50px;
}
.btn--filter {
  padding-top: 25px;
  justify-self: center;
}

.btn--filter > span {
  margin: 10px;
  cursor: pointer;
}

.active {
  background-color: #94c659;
  padding: 7px 20px;
  border-radius: 30px;
}
h1 {
  margin: 0px;
}
.title {
  position: absolute;
  font-size: 35px;
  font-weight: 600;
  padding-top: 35px;
  padding-bottom: 20px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .title {
    margin: 0px 10px;
  }
  .btn--filter {
    padding-top: 100px;
    font-size: 0.9em;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .title {
    margin: 0px 10px;
  }
  .btn--filter {
    padding-top: 100px;
    font-size: 0.9em;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }

  .title {
    margin: 0px 10px;
    font-size: 35px;
  }
  .btn--filter {
    padding-top: 100px;
    font-size: 0.8em;
  }
}

@media (max-width: 600px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }
  .btn--filter > span {
    font-size: 0.8em;
  }
  .btn--filter {
    display: flex;
    text-align: center;
  }
}
</style>
